import { render, staticRenderFns } from "./ProgramColumns.vue?vue&type=template&id=123edffb&scoped=true&"
import script from "./ProgramColumns.vue?vue&type=script&lang=ts&"
export * from "./ProgramColumns.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramColumns.vue?vue&type=style&index=0&id=123edffb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123edffb",
  null
  
)

export default component.exports